/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Reject_Title_OutInputs */

const vi_sl_detail_dialog_reject_title_out = /** @type {(inputs: Sl_Detail_Dialog_Reject_Title_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối phiếu xuất`)
};

/**

* @param {Sl_Detail_Dialog_Reject_Title_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_reject_title_out = /** @type {((inputs?: Sl_Detail_Dialog_Reject_Title_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Reject_Title_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_reject_title_out(inputs)
});